import { createPortal } from 'react-dom';

type LegalModalTheme = {
  bgCard?: string;
  border?: string;
  textPrimary?: string;
  btnPrimaryBg?: string;
  primary?: string;
  btnPrimaryColor?: string;
};

export function LegalDisclaimerModal({
  open,
  onClose,
  theme,
}: {
  open: boolean;
  onClose: () => void;
  theme: LegalModalTheme;
}) {
  if (!open) return null;
  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="legal-modal-title"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.55)',
        padding: '1rem',
      }}
      onClick={() => onClose()}
    >
      <div
        style={{
          backgroundColor: theme.bgCard ?? '#fff',
          borderRadius: '0.5rem',
          padding: '1.5rem',
          maxWidth: '26rem',
          width: '100%',
          maxHeight: '90vh',
          overflowY: 'auto',
          boxShadow: '0 30px 75px rgba(0,0,0,0.75)',
          border: `1px solid ${theme.border}`,
        }}
        onPointerDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          id="legal-modal-title"
          style={{
            margin: '0 0 1rem 0',
            fontSize: '1rem',
            fontWeight: 800,
            color: theme.textPrimary,
            lineHeight: 1.35,
            textTransform: 'uppercase',
            letterSpacing: '0.02em',
          }}
        >
          WARNING: THIS APP IS NOT FOR YOU
        </h2>
        <div style={{ fontSize: '0.8125rem', color: theme.textPrimary, lineHeight: 1.65, marginBottom: '1.25rem' }}>
          <p style={{ margin: '0 0 0.75rem 0' }}>By being here you agree we&apos;re not responsible for jack shit.</p>
          <p style={{ margin: '0 0 0.75rem 0' }}>You might lose all your ETH.</p>
          <p style={{ margin: '0 0 0.75rem 0' }}>
            You might lose your job, your girlfriend, your dog&apos;s respect, and whatever&apos;s left of your hairline.
          </p>
          <p style={{ margin: '0 0 0.75rem 0' }}>Your seed phrase might get yeeted into the void.</p>
          <p style={{ margin: '0 0 0.75rem 0' }}>
            This app contains terrible advice, gambling disguised as features, and jokes that will get you canceled in at least 47 countries.
          </p>
          <p style={{ margin: '0 0 0.75rem 0' }}>Connect your wallet anyway? That&apos;s on you, genius.</p>
          <p style={{ margin: '0 0 0.75rem 0' }}>We&apos;re not liable.</p>
          <p style={{ margin: '0 0 0.75rem 0' }}>Your mom&apos;s not liable.</p>
          <p style={{ margin: '0 0 0.75rem 0' }}>Even God is probably washing his hands of this one.</p>
          <p style={{ margin: 0, fontWeight: 700 }}>USE AT YOUR OWN RISK, YOU BEAUTIFUL MORON.</p>
        </div>
        <div style={{ textAlign: 'center' }}>
          <button
            type="button"
            onClick={() => onClose()}
            style={{
              padding: '0.5rem 1.25rem',
              fontSize: '0.875rem',
              fontWeight: 600,
              border: 'none',
              borderRadius: '0.375rem',
              backgroundColor: theme.btnPrimaryBg ?? theme.primary,
              color: theme.btnPrimaryColor ?? '#fff',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
